import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_FRONT_GET_VCASH}`;

/** 取得福利金 */
export default () => axios.get(API_PATH);
